import React, { useState } from 'react';
import './RegisterForm.css';

function RegisterForm({ onRegister, onClose, onSwitchToLogin }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await onRegister(firstName, lastName, username, password);
      if (onClose) onClose();
    } catch (err) {
      setError(err.message || 'Registration failed. Please try again.');
    }
  };

  return (
    <div className="auth-modal">
      <div className="auth-modal-content">
        <span className="close-auth" onClick={onClose}>&times;</span>
        <h2>Create Account</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="createFirstName">First Name:</label>
            <input
              type="text"
              id="createFirstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="createLastName">Last Name:</label>
            <input
              type="text"
              id="createLastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="createUsername">Username:</label>
            <input
              type="text"
              id="createUsername"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="createPassword">Password:</label>
            <input
              type="password"
              id="createPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-buttons">
            <button type="submit" className="btn btn-primary">Create Account</button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          </div>
        </form>
        <div className="form-toggle">
          <span>Already have an account? </span>
          <button type="button" className="link-btn" onClick={onSwitchToLogin}>Login here</button>
        </div>
      </div>
    </div>
  );
}

export default RegisterForm;
